// extracted by css-extract-rspack-plugin
export default {"root":"ZH4dC","border":"FlWsB"};